var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFlow = function SvgFlow(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 43,
    y1: 115.390503,
    x2: 43,
    y2: 139.766113,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 43,
    y1: 29.390499,
    x2: 43,
    y2: 53.766129,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 16.982309,
    x2: 86,
    y2: 145.982315,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 126.3125,
    y1: 16.982309,
    x2: 126.3125,
    y2: 145.987686,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 126.3125,
    y1: 16.982309,
    x2: 126.3125,
    y2: 145.987686,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9112845"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 14.84375 40.625 L 10.15625 40.625 C 9.726562 40.625 9.375 40.273438 9.375 39.84375 L 9.375 35.15625 C 9.375 34.726562 9.726562 34.375 10.15625 34.375 L 14.84375 34.375 C 15.273438 34.375 15.625 34.726562 15.625 35.15625 L 15.625 39.84375 C 15.625 40.273438 15.273438 40.625 14.84375 40.625 Z M 14.84375 40.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 14.84375 15.625 L 10.15625 15.625 C 9.726562 15.625 9.375 15.273438 9.375 14.84375 L 9.375 10.15625 C 9.375 9.726562 9.726562 9.375 10.15625 9.375 L 14.84375 9.375 C 15.273438 9.375 15.625 9.726562 15.625 10.15625 L 15.625 14.84375 C 15.625 15.273438 15.273438 15.625 14.84375 15.625 Z M 14.84375 15.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 41.296875 18.75 L 39.0625 18.75 L 39.0625 17.1875 C 39.0625 16.324219 38.363281 15.625 37.5 15.625 L 37.5 14.0625 C 37.5 12.769531 36.449219 11.71875 35.15625 11.71875 L 21.875 11.71875 C 21.875 10.855469 21.175781 10.15625 20.3125 10.15625 L 18.75 10.15625 L 18.75 8.59375 C 18.75 7.300781 17.699219 6.25 16.40625 6.25 L 8.59375 6.25 C 7.300781 6.25 6.25 7.300781 6.25 8.59375 L 6.25 16.40625 C 6.25 17.699219 7.300781 18.75 8.59375 18.75 L 16.40625 18.75 C 17.699219 18.75 18.75 17.699219 18.75 16.40625 L 18.75 14.84375 L 20.3125 14.84375 C 21.175781 14.84375 21.875 14.144531 21.875 13.28125 L 35.15625 13.28125 C 35.585938 13.28125 35.9375 13.632812 35.9375 14.0625 L 35.9375 15.625 C 35.074219 15.625 34.375 16.324219 34.375 17.1875 L 34.375 18.75 L 32.140625 18.75 C 30.789062 18.75 29.6875 19.847656 29.6875 21.203125 L 29.6875 28.800781 C 29.6875 30.152344 30.789062 31.25 32.140625 31.25 L 34.375 31.25 L 34.375 32.8125 C 34.375 33.675781 35.074219 34.375 35.9375 34.375 L 35.9375 35.9375 C 35.9375 36.367188 35.585938 36.71875 35.15625 36.71875 L 21.875 36.71875 C 21.875 35.855469 21.175781 35.15625 20.3125 35.15625 L 18.75 35.15625 L 18.75 33.59375 C 18.75 32.300781 17.699219 31.25 16.40625 31.25 L 8.59375 31.25 C 7.300781 31.25 6.25 32.300781 6.25 33.59375 L 6.25 41.40625 C 6.25 42.699219 7.300781 43.75 8.59375 43.75 L 16.40625 43.75 C 17.699219 43.75 18.75 42.699219 18.75 41.40625 L 18.75 39.84375 L 20.3125 39.84375 C 21.175781 39.84375 21.875 39.144531 21.875 38.28125 L 35.15625 38.28125 C 36.449219 38.28125 37.5 37.230469 37.5 35.9375 L 37.5 34.375 C 38.363281 34.375 39.0625 33.675781 39.0625 32.8125 L 39.0625 31.25 L 41.296875 31.25 C 42.648438 31.25 43.75 30.152344 43.75 28.796875 L 43.75 21.199219 C 43.75 19.847656 42.648438 18.75 41.296875 18.75 Z M 17.1875 16.40625 C 17.1875 16.835938 16.835938 17.1875 16.40625 17.1875 L 8.59375 17.1875 C 8.164062 17.1875 7.8125 16.835938 7.8125 16.40625 L 7.8125 8.59375 C 7.8125 8.164062 8.164062 7.8125 8.59375 7.8125 L 16.40625 7.8125 C 16.835938 7.8125 17.1875 8.164062 17.1875 8.59375 Z M 18.75 13.28125 L 18.75 11.71875 L 20.3125 11.71875 L 20.3125 13.28125 Z M 17.1875 41.40625 C 17.1875 41.835938 16.835938 42.1875 16.40625 42.1875 L 8.59375 42.1875 C 8.164062 42.1875 7.8125 41.835938 7.8125 41.40625 L 7.8125 33.59375 C 7.8125 33.164062 8.164062 32.8125 8.59375 32.8125 L 16.40625 32.8125 C 16.835938 32.8125 17.1875 33.164062 17.1875 33.59375 Z M 18.75 38.28125 L 18.75 36.71875 L 20.3125 36.71875 L 20.3125 38.28125 Z M 35.9375 17.1875 L 37.5 17.1875 L 37.5 18.75 L 35.9375 18.75 Z M 37.5 32.8125 L 35.9375 32.8125 L 35.9375 31.25 L 37.5 31.25 Z M 42.1875 28.796875 C 42.1875 29.289062 41.789062 29.6875 41.296875 29.6875 L 32.140625 29.6875 C 31.648438 29.6875 31.25 29.289062 31.25 28.796875 L 31.25 21.199219 C 31.25 20.710938 31.648438 20.3125 32.140625 20.3125 L 41.296875 20.3125 C 41.789062 20.3125 42.1875 20.710938 42.1875 21.203125 Z M 42.1875 28.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 32.8125 22.65625 L 40.625 22.65625 L 40.625 24.21875 L 32.8125 24.21875 Z M 32.8125 22.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 34.375 25.78125 L 39.0625 25.78125 L 39.0625 27.34375 L 34.375 27.34375 Z M 34.375 25.78125 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flow.2fb34eb0.svg";
export { ForwardRef as ReactComponent };